/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S8_P_Li1Inputs */

const tr_mesafeli_s8_p_li1 = /** @type {(inputs: Mesafeli_S8_P_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hizmet'i Sözleşme şartlarına ve aylık %99,5 erişilebilirlik hedefine uygun şekilde sunmak.`)
};

const en_mesafeli_s8_p_li1 = /** @type {(inputs: Mesafeli_S8_P_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To provide the Service in accordance with the terms of the Agreement and the monthly availability target of 99.5%.`)
};

const de_mesafeli_s8_p_li1 = /** @type {(inputs: Mesafeli_S8_P_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Leistung entsprechend den Vertragsbedingungen und dem monatlichen Verfügbarkeitsziel von 99,5 % erbringen.`)
};

const ru_mesafeli_s8_p_li1 = /** @type {(inputs: Mesafeli_S8_P_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оказывать Услугу в соответствии с условиями Договора и ежемесячной целью доступности 99,5 %.`)
};

/**
* | output |
* | --- |
* | "To provide the Service in accordance with the terms of the Agreement and the monthly availability target of 99.5%." |
*
* @param {Mesafeli_S8_P_Li1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s8_p_li1 = /** @type {((inputs?: Mesafeli_S8_P_Li1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S8_P_Li1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s8_p_li1(inputs)
	if (locale === "de") return de_mesafeli_s8_p_li1(inputs)
	if (locale === "ru") return ru_mesafeli_s8_p_li1(inputs)
	return tr_mesafeli_s8_p_li1(inputs)
});